<div class="queue-utilities" data-layout="row" data-layout-align="space-between center" data-layout-gap="1em">
  <mat-checkbox title="Select or Deselect All" aria-label="Select or Deselect All" [(ngModel)]="allSelected"
    (click)="selectOrDeselectAll()"></mat-checkbox>
  <!--Refer button becomes visible when any of the checkboxes are selected. Otherwise disabled.-->
  <!-- Refer -->
  <button mat-flat-button color="vdt-primary" (click)="dialogTask.openReferTaskDialog()"
    [disabled]="selectedTasks.length == 0" matTooltip="Refer selected task(s)" matTooltipPosition="below"
    matTooltipClass="tooltip"><mat-icon class="material-icons icon-size-sm">drive_file_move</mat-icon>
    ({{selectedTasks.length}})</button>
  <!-- Refresh -->
  <div data-layout="row" data-layout-align="start center">
    <span class="count">Showing: <span class="nowrap">{{countMessage}}</span></span>
    <app-refresh (iconClick)="refreshQueue()" [title]="refreshTitleText"></app-refresh>
  </div>
  <!-- Filter -->
  <button mat-icon-button title="Filter queue" (click)="openFilterDialog()" matTooltipClass="multiline-tooltip"
    matTooltip="{{filterBadgeData.text}}">
    <mat-icon matBadge={{filterBadgeData.count}} matBadgeColor="warn" matBadgeSize="small"
      [matBadgeHidden]="filterBadgeData.count==0" class="material-icons-outlined icon-dark" aria-hidden="false"
      aria-label="Filter queue">
      filter_list
    </mat-icon>
  </button>
  <span class="cdk-visually-hidden">
    Notification icon with overlaid badge showing the number {{filterBadgeData.count}}
  </span>
</div>
<!-- <div  [style.height]="calculateContainerHeight()"> -->
<cdk-virtual-scroll-viewport name="teamTasks" itemSize="159.484" style="height: calc(100vh - 250px)" #teamTasksView>
  <div *cdkVirtualFor="let task of allTasksList">
    <div *ngIf="!task.hidden">
      <app-queue-task [task]="task" [isSelectable]="true" (taskAction)="taskSelectedToggle($event)">
      </app-queue-task>
    </div>
  </div>
</cdk-virtual-scroll-viewport>
<!-- </div> -->
<app-dialog-task #dialogTask (referDialogEvent)="referDialogEvent($event)">
</app-dialog-task>

<app-task-filter [openDialog]="openDialogEvent" [tasks]="allTasks" (dialogEvent)="dialogEvent($event)"
  (displayCountEvent)="displayCountEvent($event)" [badgeData]="filterBadgeData" [filterType]="filterType">
</app-task-filter>